/**
 * DashboardSection — shared section card for Road Dashboard and Scorecard pages.
 *
 * Extracted from RoadDashboardPage.tsx (SectionCard) in BD-1 D.3 (CLEAN-J6-A3).
 * Provides a consistent Card wrapper with icon + title + optional count badge
 * and optional "Open" link for all executive dashboard sections.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { t } from '@/lib/i18n';

export interface DashboardSectionProps {
  icon?: React.ReactNode;
  title: string;
  count?: number;
  linkTo?: string;
  children: React.ReactNode;
  testId?: string;
  className?: string;
}

export function DashboardSection({
  icon,
  title,
  count,
  linkTo,
  children,
  testId,
  className = 'space-y-3',
}: DashboardSectionProps) {
  return (
    <Card padding="md" className={className} data-testid={testId}>
      <div className="flex items-center justify-between">
        <h2 className="text-base font-semibold text-foreground flex items-center gap-2">
          {icon}
          {title}
          {typeof count === 'number' && (
            <Badge variant="default" className="text-xs">{count}</Badge>
          )}
        </h2>
        {linkTo && (
          <Link to={linkTo} className="text-xs text-primary-600 hover:underline">
            {t('Open')}
          </Link>
        )}
      </div>
      {children}
    </Card>
  );
}
